import * as React from 'react';

import Icon from 'components/atoms/Icon';

export type IconInfoProps = {
	icon: string;
	value?: string;
	unit?: string;
	modifier?: string;
};

export const IconInfo = ({ icon, value, unit, modifier }: IconInfoProps) => {
	const classNames = ['a-icon-info'];

	if (modifier) {
		classNames.push(`${classNames[0]}--${modifier}`);
	}

	return (
		<div className={classNames.join(' ')}>
			<span className="a-icon-info__icon">
				<Icon iconName={icon} />
			</span>
			<span className={`a-icon-info__info ${unit === undefined && `a-icon-info__info--align`}`}>
				{value && <span className="a-icon-info__value">{value}</span>}
				{unit && <span className="a-icon-info__unit">{unit}</span>}
			</span>
		</div>
	);
};

IconInfo.displayName = 'IconInfo';

export default IconInfo;
